import axiosInstance from "../utils/axios";

const API_ENDPOINTS = {
  INTEGRATION: "api/Integration",
  FACEBOOK: "api/Facebook",
};

export const getFacebookLoginUrl = async (providerId) => {
  if (!providerId) {
    return {
      success: false,
      error: "ProviderId is required to fetch Facebook login URL",
      data: null,
    };
  }

  try {
    const response = await axiosInstance.get(
      `${API_ENDPOINTS.FACEBOOK}/login`,
      {
        params: {
          ProviderId: providerId,
        },
      },
    );

    if (response?.data?.loginUrl) {
      return {
        success: true,
        data: response.data,
        message: "Facebook login URL fetched successfully",
      };
    }

    throw new Error("Unexpected response while fetching Facebook login URL");
  } catch (error) {
    console.error("Error fetching Facebook login URL:", error);

    return {
      success: false,
      error: error.message || "Failed to fetch Facebook login URL",
      data: null,
    };
  }
};

export const getGoogleCalendarAuthUrl = async () => {
  try {
    const response = await axiosInstance.get("/api/Integration/google-calendar/auth");

    if (response?.data?.url) {
      return {
        success: true,
        data: response.data,
        message: "Google Calendar auth URL fetched successfully",
      };
    }

    throw new Error("Unexpected response while fetching Google Calendar auth URL");
  } catch (error) {
    console.error("Error fetching Google Calendar auth URL:", error);

    return {
      success: false,
      error: error.message || "Failed to fetch Google Calendar auth URL",
      data: null,
    };
  }
};

export const disconnectGoogleCalendar = async (integrationId) => {
  if (!integrationId) {
    return {
      success: false,
      error: "IntegrationId is required to disconnect Google Calendar",
      data: null,
    };
  }

  try {
    const response = await axiosInstance.get("/api/Integration/google-calendar/disconnect", {
      params: {
        integrationId: integrationId,
      },
    });

    const responseData = response.data || {};

    if (responseData.statusCode === 200 && responseData.status === "Success") {
      return {
        success: true,
        data: responseData.data ?? null,
        message: responseData.message || "Google Calendar disconnected successfully",
      };
    }

    throw new Error(
      responseData.error ||
        responseData.message ||
        "Failed to disconnect Google Calendar",
    );
  } catch (error) {
    console.error("Error disconnecting Google Calendar:", error);

    return {
      success: false,
      error: error.message || "Failed to disconnect Google Calendar",
      data: null,
    }}}

export const testTwilioCall = async (payload) => {
  try {
    const response = await axiosInstance.post(
      `${API_ENDPOINTS.INTEGRATION}/TestTwelioCall`,
      payload,{
        showLoader:false
      }
    );

    return {
      success: true,
      data: response.data,
      message: "Test call initiated successfully"
    };
  } catch (error) {
    console.error("Error testing Twilio call:", error);
    return {
      success: false,
      error: error.response?.data?.message || error.message || "Failed to initiate test call",
      data: null
    };
  }
};
export const getTwilioCallStatus = async (callSid) => {
  try {
    const response = await axiosInstance.get(
      `${API_ENDPOINTS.INTEGRATION}/twilio/get-call-status`,
      {
        params: {
          callSid: callSid
        }
      }
      ,{
        showLoader:false
      }
    );

    return {
      success: true,
      data: response.data,
      message: "Call status retrieved successfully"
    };
  } catch (error) {
    console.error("Error getting Twilio call status:", error);
    return {
      success: false,
      error: error.response?.data?.message || error.message || "Failed to get call status",
      data: null
    };
  }
};

export const deactivateIntegrationStatus = async (integrationProviderId, isActive) => {
  if (!integrationProviderId || typeof isActive === "undefined") {
    return {
      success: false,
      error: "IntegrationProviderId and IsActive are required to update status",
      data: null,
    };
  }

  try {
    const response = await axiosInstance.put(
      `${API_ENDPOINTS.INTEGRATION}/DeactivateIntegrationStatus`,
      null,
      {
        params: {
          IntegrationProviderId: integrationProviderId,
          IsActive: isActive,
        },
      },
    );

    const responseData = response.data || {};

    if (responseData.statusCode === 200 && responseData.status === "Success") {
      return {
        success: true,
        data: responseData.data ?? null,
        message: responseData.message || "Integration status updated successfully",
        totalRecords: responseData.totalRecords ?? 0,
      };
    }

    throw new Error(
      responseData.error ||
        responseData.message ||
        "Failed to update integration status",
    );
  } catch (error) {
    console.error("Error updating integration status:", error);

    return {
      success: false,
      error: error.message || "Failed to update integration status",
      data: null,
      totalRecords: 0,
    };
  }
};

export const setDefaultFacebookPage = async (pageId) => {
  if (!pageId) {
    return {
      success: false,
      error: "PageId is required to set default Facebook page",
      data: null,
    };
  }

  try {
    const response = await axiosInstance.get(
      `${API_ENDPOINTS.FACEBOOK}/set-default-facebook-page/${pageId}`,
    );
    const responseData = response.data || {};

    if (responseData.statusCode === 200 && responseData.status === "Success") {
      return {
        success: true,
        data: responseData.data ?? null,
        message:
          responseData.message || "Default Facebook page updated successfully",
      };
    }

    throw new Error(
      responseData.error ||
        responseData.message ||
        "Failed to set default Facebook page",
    );
  } catch (error) {
    console.error("Error setting default Facebook page:", error);

    return {
      success: false,
      error: error.message || "Failed to set default Facebook page",
      data: null,
    };
  }
};

export const setDefaultWhatsAppNumber = async (numberId) => {
  if (!numberId) {
    return {
      success: false,
      error: "NumberId is required to set default WhatsApp number",
      data: null,
    };
  }

  try {
    const response = await axiosInstance.get(
      `${API_ENDPOINTS.FACEBOOK}/set-default-whatsapp-number/${numberId}`,
    );
    const responseData = response.data || {};

    if (responseData.statusCode === 200 && responseData.status === "Success") {
      return {
        success: true,
        data: responseData.data ?? null,
        message:
          responseData.message || "Default WhatsApp number updated successfully",
      };
    }

    throw new Error(
      responseData.error ||
        responseData.message ||
        "Failed to set default WhatsApp number",
    );
  } catch (error) {
    console.error("Error setting default WhatsApp number:", error);

    return {
      success: false,
      error: error.message || "Failed to set default WhatsApp number",
      data: null,
    };
  }
};

export const setFacebookPageActiveStatus = async (pageId, isActive) => {
  if (!pageId || typeof isActive === "undefined") {
    return {
      success: false,
      error: "PageId and isActive are required to update Facebook page status",
      data: null,
    };
  }

  try {
    const response = await axiosInstance.get(
      `${API_ENDPOINTS.FACEBOOK}/active-inactive-page`,
      {
        params: {
          PageId: pageId,
          isactive: isActive,
        },
      },
    );

    const responseData = response.data || {};

    if (responseData.statusCode === 200 && responseData.status === "Success") {
      return {
        success: true,
        data: responseData.data ?? null,
        message:
          responseData.message || "Facebook page status updated successfully",
      };
    }

    throw new Error(
      responseData.error ||
        responseData.message ||
        "Failed to update Facebook page status",
    );
  } catch (error) {
    console.error("Error updating Facebook page status:", error);

    return {
      success: false,
      error: error.message || "Failed to update Facebook page status",
      data: null,
    };
  }
};

export const setWhatsAppNumberActiveStatus = async (numberId, isActive) => {
  if (!numberId || typeof isActive === "undefined") {
    return {
      success: false,
      error: "NumberId and isActive are required to update WhatsApp number status",
      data: null,
    };
  }

  try {
    const response = await axiosInstance.get(
      `${API_ENDPOINTS.FACEBOOK}/active-inactive-whatsapp-number`,
      {
        params: {
          NumnerId: numberId,
          isactive: isActive,
        },
      },
    );

    const responseData = response.data || {};

    if (responseData.statusCode === 200 && responseData.status === "Success") {
      return {
        success: true,
        data: responseData.data ?? null,
        message:
          responseData.message || "WhatsApp number status updated successfully",
      };
    }

    throw new Error(
      responseData.error ||
        responseData.message ||
        "Failed to update WhatsApp number status",
    );
  } catch (error) {
    console.error("Error updating WhatsApp number status:", error);

    return {
      success: false,
      error: error.message || "Failed to update WhatsApp number status",
      data: null,
    };
  }
};

export const exchangeFacebookCodeForToken = async (code, providerId) => {
  if (!code || !providerId) {
    return {
      success: false,
      error: "Code and ProviderId are required to exchange token",
      data: null,
    };
  }

  try {
    const response = await axiosInstance.get(
      `${API_ENDPOINTS.FACEBOOK}/ExchangeCodeForAccessToken`,
      {
        params: {
          code,
          ProviderId: providerId,
        },
      },
    );

    const responseData = response.data || {};

    if (responseData.statusCode === 200 && responseData.status === "Success") {
      return {
        success: true,
        data: responseData.data ?? null,
        message:
          responseData.message || "OAuth callback processed successfully",
      };
    }

    throw new Error(
      responseData.error ||
        responseData.message ||
        "Failed to exchange code for access token",
    );
  } catch (error) {
    console.error("Error exchanging Facebook code for token:", error);

    return {
      success: false,
      error: error.message || "Failed to exchange code for access token",
      data: null,
    };
  }
};

export const upsertIntegrationConfiguration = async (payload = {}) => {
  const { integrationConfigId, integrationProviderId, secrets = {} } = payload;

  if (!integrationProviderId) {
    return {
      success: false,
      error: "Integration provider id is required to upsert configuration",
      data: null,
    };
  }

  try {
    const response = await axiosInstance.post(
      `${API_ENDPOINTS.INTEGRATION}/UpsertIntegrationConfiguration`,
      {
        ...(integrationConfigId ? { integrationConfigId } : {}),
        integrationProviderId,
        secrets,
      },
    );

    const responseData = response.data || {};

    if (responseData.statusCode === 200 && responseData.status === "Success") {
      let parsedData = responseData.data;

      if (typeof parsedData === "string") {
        try {
          parsedData = JSON.parse(parsedData);
        } catch (parseError) {
          console.error("Error parsing integration configuration response:", parseError);
          parsedData = [];
        }
      }

      const totalRecords = responseData.totalRecords ?? (Array.isArray(parsedData) ? parsedData.length : 0);

      return {
        success: true,
        data: parsedData,
        totalRecords,
        message: responseData.message || "Integration configuration updated successfully",
      };
    }

    throw new Error(
      responseData.error ||
        responseData.message ||
        "Failed to upsert integration configuration",
    );
  } catch (error) {
    console.error("Error upserting integration configuration:", error);

    return {
      success: false,
      error: error.message || "Failed to upsert integration configuration",
      data: null,
      totalRecords: 0,
    };
  }
};

export const getIntegrationProviders = async () => {
  try {
    const response = await axiosInstance.get(
      `${API_ENDPOINTS.INTEGRATION}/GetAllIntegrationProviders`,
    );
    const responseData = response.data;

    if (responseData.statusCode === 200 && responseData.status === "Success") {
      let providers = [];

      if (typeof responseData.data === "string") {
        try {
          providers = JSON.parse(responseData.data);
        } catch (parseError) {
          console.error("Error parsing integration providers:", parseError);
          providers = [];
        }
      } else if (Array.isArray(responseData.data)) {
        providers = responseData.data;
      }

      return {
        success: true,
        data: providers,
        totalRecords: responseData.totalRecords ?? providers.length,
        message:
          responseData.message || "Integration providers fetched successfully",
      };
    }

    throw new Error(responseData.message || "Failed to fetch integration providers");
  } catch (error) {
    console.error("Error fetching integration providers:", error);

    return {
      success: false,
      error: error.message || "Failed to fetch integration providers",
      data: [],
      totalRecords: 0,
    };
  }
};

export const getFacebookWabas = async () => {
  try {
    const response = await axiosInstance.get(
      `${API_ENDPOINTS.FACEBOOK}/get-waba`,
    );
    const responseData = response.data;

    if (responseData.statusCode === 200 && responseData.status === "Success") {
      let wabaList = [];

      if (typeof responseData.data === "string") {
        try {
          wabaList = JSON.parse(responseData.data);
        } catch (parseError) {
          console.error("Error parsing Facebook WABA data:", parseError);
          wabaList = [];
        }
      } else if (Array.isArray(responseData.data)) {
        wabaList = responseData.data;
      }

      return {
        success: true,
        data: wabaList,
        totalRecords: responseData.totalRecords ?? wabaList.length,
        message: responseData.message || "WABA accounts fetched successfully",
      };
    }

    throw new Error(responseData.message || "Failed to fetch WABA accounts");
  } catch (error) {
    console.error("Error fetching Facebook WABA accounts:", error);

    return {
      success: false,
      error: error.message || "Failed to fetch WABA accounts",
      data: [],
      totalRecords: 0,
    };
  }
};

export const getFacebookConnectedPages = async () => {
  try {
    const response = await axiosInstance.get(
      `${API_ENDPOINTS.FACEBOOK}/get-connected-pages`,
    );
    const responseData = response.data;

    if (responseData.statusCode === 200 && responseData.status === "Success") {
      let pagesList = [];

      if (typeof responseData.data === "string") {
        try {
          pagesList = JSON.parse(responseData.data);
        } catch (parseError) {
          console.error("Error parsing Facebook pages data:", parseError);
          pagesList = [];
        }
      } else if (Array.isArray(responseData.data)) {
        pagesList = responseData.data;
      }

      return {
        success: true,
        data: pagesList,
        totalRecords: responseData.totalRecords ?? pagesList.length,
        message: responseData.message || "Facebook pages fetched successfully",
      };
    }

    throw new Error(responseData.message || "Failed to fetch Facebook pages");
  } catch (error) {
    console.error("Error fetching Facebook connected pages:", error);

    return {
      success: false,
      error: error.message || "Failed to fetch Facebook connected pages",
      data: [],
      totalRecords: 0,
    };
  }
};

export const getIntegrationsByType = async (integrationTypeName) => {
  if (!integrationTypeName) {
    return {
      success: false,
      error: "IntegrationTypeName is required to fetch integrations by type",
      data: [],
      totalRecords: 0,
    };
  }

  try {
    const response = await axiosInstance.post(
      `${API_ENDPOINTS.INTEGRATION}/GetIntegrationsByType`,
      {
        integrationTypeName: integrationTypeName,
      }
    );

    const responseData = response.data;

    if (responseData.statusCode === 200 && responseData.status === "Success") {
      let integrations = [];

      if (typeof responseData.data === "string") {
        try {
          integrations = JSON.parse(responseData.data);
        } catch (parseError) {
          console.error("Error parsing integrations data:", parseError);
          integrations = [];
        }
      } else if (Array.isArray(responseData.data)) {
        integrations = responseData.data;
      }

      return {
        success: true,
        data: integrations,
        totalRecords: responseData.totalRecords ?? integrations.length,
        message: responseData.message || "Integrations fetched successfully",
      };
    }

    throw new Error(responseData.message || "Failed to fetch integrations by type");
  } catch (error) {
    console.error("Error fetching integrations by type:", error);

    return {
      success: false,
      error: error.message || "Failed to fetch integrations by type",
      data: [],
      totalRecords: 0,
    };
  }
};
